/* Runtime settings of the console. One build for every environment: the values come from
 * /config.json next to index.html when present (written at deploy), else from the dev defaults. */
export interface ConsoleConfig {
  apiUrl: string;
}

const DEV: ConsoleConfig = {
  apiUrl: 'http://localhost:3000',
};

export async function loadConfig(): Promise<ConsoleConfig> {
  try {
    const response = await fetch('/config.json', { cache: 'no-cache' });
    if (response.ok) return { ...DEV, ...((await response.json()) as Partial<ConsoleConfig>) };
  } catch {
    // No deploy-time config: local development.
  }
  return DEV;
}
